export const DELIMITER = {
    TAB: 1,
    COMMA: 2,
    SEMICOLON: 3,
    SPACE: 4
};
export const OTHER_DELIMITER_ID = 0;
